import { connectConsumer } from "../modules/redux-consumer";
import AdapterJS from "adapterjs";
import detect from "detect-browser";
import waitForDom from "../modules/wait-for-dom";

const localStateConsumer = ({ stream }) => {
  console.log("setting local video");

  waitForDom("local-video")
    .then(element => {
      console.log("got dom element. setting srcObject.");
      element.srcObject = stream;
      if (detect.detect().name === "ie") {
        AdapterJS.attachMediaStream(element, stream);
      }
      element.setAttribute("playsinline", true);
      element.play();
    })
    .catch(err => {
      console.log(`ERROR: ${err}`);
    });
};

const mapStateToProps = localStream => ({
  stream: localStream,
});

const selector = state => state.config.localStream;
const filter = localStream => localStream != null;
export default connectConsumer(
  mapStateToProps,
  null,
  selector,
  filter
)(localStateConsumer);






// WEBPACK FOOTER //
// ./src/consumers/localStreamConsumer.js